import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setSectionProperty } from '../../actions/sections/SectionsActions'
import './Overlay.css'

@connect((state) => ({}), { setSectionProperty })
class Overlay extends Component {
  clickHandler = () => {
    const { setSectionProperty } = this.props
    setSectionProperty('overlay', 'isVisible', false)
    setSectionProperty('slideUpMenu', 'open', false)
  }
  render() {
    return (
      <div className="Overlay" onClick={this.clickHandler}>

      </div>
    )
  }
}

export default Overlay


// WEBPACK FOOTER //
// ./src/components/Overlay/index.js